export default __webpack_public_path__ + "static/media/10AW3FEB66.c158d025.jpg";